import { useEffect, useRef } from "react";
import * as THREE from "three";

export default function LiquidGlassBackground() {
  const mountRef = useRef();

  useEffect(() => {
    const scene = new THREE.Scene();
    const camera = new THREE.OrthographicCamera(-1, 1, 1, -1, 0, 1);
    const renderer = new THREE.WebGLRenderer({ alpha: true });
    renderer.setSize(200, window.innerHeight);
    renderer.setClearColor(0x000000, 0);
    mountRef.current.appendChild(renderer.domElement);

    const uniforms = {
      time: { value: 0.0 },
      resolution: {
        value: new THREE.Vector2(window.innerWidth, window.innerHeight),
      },
    };

    const material = new THREE.ShaderMaterial({
      uniforms,
      vertexShader: `
                void main() {
                    gl_Position = vec4(position, 1.0);
                }
            `,
      fragmentShader: `
                precision mediump float;
                uniform float time;
                uniform vec2 resolution;

                void main() {
                    vec2 uv = gl_FragCoord.xy / resolution.xy;

                    vec2 center = vec2(0.5) + 0.02 * vec2(sin(time * 0.8), cos(time * 1.2));

                    float dist = distance(uv, center);
                    float ripple = 0.03 * sin(40.0 * dist - time * 4.0);

                    vec2 offset = normalize(uv - center) * ripple;

                    vec3 color = vec3(0.95, 0.95, 1.0) + ripple;

                    gl_FragColor = vec4(color, 0.12 + ripple);
                }
            `,
      transparent: true,
    });

    const geometry = new THREE.PlaneGeometry(2, 2);
    const mesh = new THREE.Mesh(geometry, material);
    scene.add(mesh);

    const animate = () => {
      uniforms.time.value += 0.02;
      renderer.render(scene, camera);
      requestAnimationFrame(animate);
    };
    animate();

    return () => {
      if (mountRef.current && renderer.domElement) {
        mountRef.current.removeChild(renderer.domElement);
      }
    };
  }, []);

  return (
    <div
      ref={mountRef}
      style={{
        position: "absolute",
        left: 0,
        top: 0,
        width: "200px",
        height: "100vh",
        zIndex: -1,
        pointerEvents: "none",
      }}
    />
  );
}
